import { createGlobalStyle } from 'styled-components';

import {
  inheritedControlTypographyStyles,
  structuralControlResetStyles,
} from '../shared/ui';

export const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100%;
  }

  body {
    overflow: hidden;
    overscroll-behavior: none;
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: Inter, sans-serif;
    line-height: 1.21;
  }

  button,
  input,
  textarea,
  select {
    ${inheritedControlTypographyStyles};
  }

  button,
  input {
    ${structuralControlResetStyles};
  }
`;
